module.exports = __webpack_public_path__ + "static/gallery40-e2427f28af86241508f3b6e0936b9a27.jpg";